<template>
	<ld-popup
		title="Desbloqueio de empresa"
		:active.sync="active"
		:button-close-hidden="true"
	>
		<p>
			Tem certeza que deseja desbloquear a empresa?
		</p>

		<vs-divider />

		<div class="button-container">
			<div class="button-group flex justify-end">

				<ld-button
					class="w-15 mr-4"
					color="dark"
					type="flat"
					@click="active = false"
					>Cancelar</ld-button
				>

				<ld-button
					buttonType="submit"
					class="w-20"
					color="primary"
					type="filled"
					@click="reativar"
					>Desbloquear</ld-button
				>
			</div>
		</div>
	</ld-popup>
</template>

<script>
export default {
	name: "PopupReativarEmpresa",
	props: {
		show: {
			type: Boolean,
			default: false
		},
		reativar: {
			type: Function
		}
	},
	computed: {
		active: {
			set(value) {
				this.$emit("update:show", value);
			},
			get() {
				return this.show;
			}
		}
	}
};
</script>
